import React, { useState } from 'react';
import SimpleReactValidator from 'simple-react-validator';
import { useForm } from '@formspree/react';

const ContactForm = (props) => {
  const [state, formspreeSubmit] = useForm("xkgoyapn");
  const [submitted, setSubmitted] = useState(false);

  const [forms, setForms] = useState({
    name: '',
    email: 'abc@gmail.com',
    subject: '',
    phone: '+8250-3560 6565',
    message: ''
  });

  const [validator] = useState(new SimpleReactValidator({
    className: 'errorMessage'
  }));

  const changeHandler = (e) => {
    setForms({ ...forms, [e.target.name]: e.target.value });
    if (validator.allValid()) {
      validator.hideMessages();
    } else {
      validator.showMessages();
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (validator.allValid()) {
      validator.hideMessages();
      // Submit the form via Formspree
      await formspreeSubmit(e);
      // Reset form fields
      setForms({
        name: '',
        email: '',
        subject: '',
        phone: '',
        message: ''
      });
      // Show success message
      setSubmitted(true);
    } else {
      validator.showMessages();
    }
  };
  if (state.succeeded) {
    return (
      <div className="success-message">
        <h2>Thank You!</h2>
        <p>Your message has been sent successfully.</p>
      </div>
    );
  }

  return (
    <form onSubmit={onSubmit}>
      <div className="row">
        {/* Full Name */}
        <div className="col-md-6">
          <div className="form-group">
            <label className="input_title" htmlFor="input_name">Full Name</label>
            <input
              value={forms.name}
              type="text"
              name="name"
              className="form-control"
              onBlur={changeHandler}
              onChange={changeHandler}
              placeholder="Goladria Gomez"
              required
            />
            {validator.message('name', forms.name, 'required|alpha_space')}
          </div>
        </div>

        {/* Your Email */}
        <div className="col-md-6">
          <div className="form-group">
            <label className="input_title" htmlFor="input_email">Your Email</label>
            <input
              value={forms.email}
              type="email"
              name="email"
              className="form-control"
              onBlur={changeHandler}
              onChange={changeHandler}
              placeholder="zarnixtech@gmail.com"
              required
            />
            {validator.message('email', forms.email, 'required|email')}
          </div>
        </div>

        {/* Subject */}
        <div className="col-12">
          <div className="form-group">
            <label className="input_title" htmlFor="input_subject">Subject</label>
            <input
              value={forms.subject}
              type="text"
              name="subject"
              className="form-control"
              onBlur={changeHandler}
              onChange={changeHandler}
              placeholder="Subject"
              required
            />
            {validator.message('subject', forms.subject, 'required')}
          </div>
        </div>

        {/* Your Phone */}
        <div className="col-12">
          <div className="form-group">
            <label className="input_title" htmlFor="input_phone">Your Phone</label>
            <input
              value={forms.phone}
              type="tel"
              name="phone"
              className="form-control"
              onBlur={changeHandler}
              onChange={changeHandler}
              placeholder="+8250-3560 6565"
              required
            />
            {validator.message('phone', forms.phone, 'required|phone')}
          </div>
        </div>

        {/* Message */}
        <div className="col-12">
          <div className="form-group">
            <label className="input_title" htmlFor="input_textarea">Message</label>
            <textarea
              value={forms.message}
              name="message"
              className="form-control"
              onBlur={changeHandler}
              onChange={changeHandler}
              placeholder="How can we help you?"
              required
            ></textarea>
            {validator.message('message', forms.message, 'required')}
          </div>

          {/* Submit Button */}
          <button type="submit" className="btn btn-primary">
            <span className="btn_label" data-text="Send Message">Send Message</span>
            <span className="btn_icon">
              <i className="fa-solid fa-arrow-up-right"></i>
            </span>
          </button>
        </div>
      </div>
    </form>
  );
};

export default ContactForm;
